import { render, staticRenderFns } from "./ModalErrorNumberOfDoses.vue?vue&type=template&id=1e65f6e3&"
import script from "./ModalErrorNumberOfDoses.vue?vue&type=script&lang=js&"
export * from "./ModalErrorNumberOfDoses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports